@if (componentData.data$ | async; as component) {
  <div class="logo-container container">
    <h2 class="logo-container__title">{{ component?.title }}</h2>
    @if (component.logos) {
      <div class="logos">
        @for (logo of logos$ | async; track logo) {
          <div class="logo-item">
            <img
              class="logo-item__img"
              src="{{ getLogoUrl(logo) }}"
              [alt]="logo?.altText"
              loading="lazy"
            />
          </div>
        }
      </div>
    }
  </div>
}
